/* eslint-disable arrow-parens */
import React, { Component } from 'react';
import { push } from 'react-router-redux'
import { store } from '../../stores/configureStore';
import { IconButton } from 'material-ui';
import TextField from 'material-ui/TextField';
import Box from '../ui/Box';

//services
import LocalStorageService from '../../services/LocalStorageService'; var ls = LocalStorageService;
import DataService from '../../services/DataService';
var ds = DataService;
import MessageService from '../../services/MessageService';
var _mqtt = MessageService;


export default class RoomsConsolidated extends Component {
  constructor() {
    super();
    this.state = {
      all_rooms: [],
      all_rooms_raw: [],
      rooms_map: {},
      device_statuses: {},
      room_dnd_map: {},
      search_field: ''
    };
  }

  componentDidMount() {
    this.startFunc();
    
    window.addEventListener('_mqt', (e) => {
      if (e && e.detail) {
        if (e.detail.data && e.detail.data.switch) {
          let x = this.state.device_statuses;
          if (!x) {
            x = {};
          }
          x[e.detail.device_id] = e.detail.data.switch.relays;
          this.setState({
            device_statuses: x
          });
        }
      }
    });
  }
  
  componentWillUnmount() {
    window.removeEventListener('_mqt', this.mqttListener);
  }

  startFunc() {
    this.getAllRooms();
    this.getStatuses();
  }

  enrichRooms(data) {
    return data.map((i) => {
      let room_is_empty = true;
      let check_out_string = "";
      if (i.check_in_time && i.check_out_time) {
        let cell = i.check_in_time;
        let start = new Date(cell);
        let end = new Date(i.check_out_time);
        let today = new Date();
        if (start <= today && end > today) {
          room_is_empty = false;
          check_out_string = end.getDate() + '/' + end.getMonth() + '/' + end.getFullYear();
        } else {
          room_is_empty = true;
        }
      } else {
        room_is_empty = true;
      }
      return { ...i, room_is_empty: room_is_empty, check_out_string: check_out_string };
    });
  }

  groupRoomsByFloor(rooms) {
    let x = {};
    for (let i of rooms) {
      if (i.hotel_room_id) {
        if (!x[i.hotel_room_id.floor]) {
          x[i.hotel_room_id.floor] = [];
        }
        x[i.hotel_room_id.floor].push(i);
      }
    }
    let all_rooms = [];
    for (const i in x) {
      all_rooms.push({
        name: i,
        rooms: x[i]
      })
    }
    return all_rooms;
  }

  getAllRooms() {
    ds.getSomeRooms(ls.getUserDetails().hotel_id, 0, 0,
      data => {
        let enriched = this.enrichRooms(data);
        this.setState({
          all_rooms_raw: enriched,
          all_rooms: this.groupRoomsByFloor(enriched)
        });

        this.fetchDNDSwitches(data);
      }, err => {
        console.log(err);
      })
  }

  searchRooms() {
    if (this.state.search_field) {
      let searchString = this.state.search_field;
      let filtered = this.state.all_rooms_raw.filter((room) => {
        return room.hotel_room_id && room.hotel_room_id.name &&
          room.hotel_room_id.name.toLowerCase().lastIndexOf(searchString.toLowerCase(), 0) === 0;
      });
      this.setState({
        all_rooms: this.groupRoomsByFloor(filtered)
      });
    } else {
      this.setState({
        all_rooms: this.groupRoomsByFloor(this.state.all_rooms_raw)
      });
    }
  }

  fetchDNDSwitches(rooms) {
    let dnd_map = {};
    
    rooms.forEach((room) => {
      if (room.hotel_room_id && room.hotel_room_id._id) {
        ds.getSwitchesInRoom(room.hotel_room_id._id, data => {
          if (data && data.switchAppliances && data.switchAppliances.length) {
            const dndSwitch = data.switchAppliances.find(sw => 
              sw.feature && Array.isArray(sw.feature) && sw.feature.some(f => f.id === 8)
            );
            
            if (dndSwitch) {
              dnd_map[room.hotel_room_id._id] = {
                device_id: dndSwitch.device_id,
                switch_no: dndSwitch.switch_no
              };
              
              this.setState({
                room_dnd_map: {...this.state.room_dnd_map, ...dnd_map}
              });
              
              if (data.mqttPassword) {
                _mqtt.connect(room.hotel_room_id._id, data.mqttPassword).then(() => {
                  for (let i in data.devicesInfo) {
                    _mqtt.unsafePublish(room.hotel_room_id._id, i, data.devicesInfo[i].encryptKey);
                  }
                });
              }
            }
          }
        }, err => {
          console.log('Error fetching switches for room:', err);
        });
      }
    });
  }
  getStatuses() {
    ds.getRoomStatuses(ls.getUserDetails().hotel_id,
      data => {
        let x = {};
        if (data && data.length) {
          for (let i of data) {
            x[i.room_id] = i;
          }
        }
        this.setState({
          rooms_map: x
        })
      }, err => {
        console.log(err);
      })
  }

  goToRoomControl(room) {
    store.dispatch(push(`/app/rooms/control/${room._id}_${room.hotel_room_id ? room.hotel_room_id._id : ''}`));
  }
  
  isDNDActive(room) {
    if (!room.hotel_room_id || !room.hotel_room_id._id) {
      return false;
    }
    
    const roomId = room.hotel_room_id._id;
    const dndInfo = this.state.room_dnd_map[roomId];
    
    if (!dndInfo) {
      return false;
    }
    
    const deviceStatuses = this.state.device_statuses[dndInfo.device_id];
    
    if (!deviceStatuses || !Array.isArray(deviceStatuses)) {
      return false;
    }
    
    return deviceStatuses[dndInfo.switch_no - 1] === 1;
  }

  render() {
    return (
      <div>
        <Box header='All Rooms'>

          <IconButton aria-label="Refresh" onClick={this.startFunc.bind(this)} className='customRefresh'>
            <i className="material-icons">refresh</i>
          </IconButton>

          <TextField
            floatingLabelText="Search Room"
            className="w-100"
            value={this.state.search_field}
            onChange={(e) => {
              this.setState({
                search_field: e.target.value
              }, () => {
                this.searchRooms();
              });
            }}
          />

          {
            this.state.all_rooms && this.state.all_rooms.length ?
              this.state.all_rooms.map((floor, ind) => {
                if (floor.rooms && floor.rooms.length) {
                  return <div className="col-sm-12">
                    {
                      this.state.all_rooms.length > 1 ? 
                        <div style={{ color: "black", marginLeft: "1vw", marginBottom: "1vw", marginTop: "1vw", fontSize: "1.3rem" }}>
                          {floor.name && floor.name != 'undefined' ? "Floor " + floor.name : 'Other'}
                        </div> 
                      : null
                    }
                    {
                      floor.rooms.map((room, ind2) => {
                      return room.hotel_room_id ? 
                        <div key={room._id} className="col-xl-3 col-sm-6" style={{ cursor: "pointer" }} onClick={this.goToRoomControl.bind(this, room)}>
                          <div className="box box-default customBox">
                          <div style={{textAlign: "end"}}>
                            {this.isDNDActive(room) ? 
                            <i className="material-icons" style={{color: 'red', margin: '5px', fontSize: '1.5rem'}}>do_not_disturb</i> :
                            room.room_is_empty ? 
                            <i className="material-icons" style={{color: 'green', margin: '5px', fontSize: '1.5rem'}}>done</i> :
                             <div><span style={{position: 'relative',top: '-4px'}}>{room.check_out_string}</span> <i className="material-icons" style={{color: 'red', margin: '5px', fontSize: '1.5rem'}}>cancel</i></div>
                             }
                             </div>
                            <div className="box-top">
                              <span> {this.state.rooms_map[room.hotel_room_id._id] ? this.state.rooms_map[room.hotel_room_id._id].activeAppliances : 0}<span className="green-fg" style={{ fontSize: "0.7rem", marginLeft: "0.2vw" }}>ON</span> </span>
                            </div>

                            <div className="box-info">
                              <span style={{ fontSize: "1.5rem", height: "30px", lineHeight: "23px" }}>{room.hotel_room_id.name}</span>
                            </div>

                            <div className="box-bottom row" style={{ fontSize: "1.7rem", padding: "1vw", height: "70px", paddingTop: "1.5vw", margin: 0 }}>
                              <div className="col-md-6 col-6">{this.state.rooms_map[room.hotel_room_id._id] ? this.state.rooms_map[room.hotel_room_id._id].totalAppliances - this.state.rooms_map[room.hotel_room_id._id].activeAppliances : 0} <span style={{ fontSize: "0.7rem" }} className="warn-fg">OFF</span></div>
                              <div className="col-md-6 col-6"> {this.state.rooms_map[room.hotel_room_id._id] ? this.state.rooms_map[room.hotel_room_id._id].totalAppliances : 0} <span style={{ fontSize: "0.7rem", color: "$gray-600" }}>TOTAL</span></div>
                            </div>
                          </div>
                        </div> 
                      : null
                      })
                    }
                  </div>
                }
                else {
                  return null;
                }
              })
            : "No Roooms Found :("
          }
        </Box>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./components/rooms/RoomsConsolidated.js